<template>
  <svg
    id="Layer_1"
    enable-background="new 0 0 512.011 512.011"
    viewBox="0 0 512.011 512.011"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="m356.183 341.511h-71.164v41.608c0 15.998-13.016 29.013-29.014 29.013s-29.014-13.015-29.014-29.013v-41.608h-71.164c-51.257 0-92.958 41.701-92.958 92.958v77.542h386.271v-77.542c.001-51.257-41.7-92.958-92.957-92.958z"
        fill="#7c84e8"
      />
      <path
        d="m449.141 434.469c0-51.257-41.701-92.958-92.958-92.958h-71.164v41.608c0 15.998-13.016 29.013-29.014 29.013v99.879h193.136z"
        fill="#424ede"
      />
      <path
        d="m196.992 341.511v41.608c0 32.54 26.474 59.013 59.014 59.013s59.014-26.473 59.014-59.013v-41.608z"
        fill="#915041"
      />
      <path
        d="m256.005 341.511v100.621c32.54 0 59.014-26.473 59.014-59.013v-41.608z"
        fill="#663328"
      />
      <path
        d="m391.356 159.655h-34.702v89.085h34.702c24.561 0 44.542-19.981 44.542-44.542s-19.981-44.543-44.542-44.543z"
        fill="#915041"
      />
      <path
        d="m391.356 159.655h-34.702v89.085h34.702c24.561 0 44.542-19.981 44.542-44.542s-19.981-44.543-44.542-44.543z"
        fill="#663328"
      />
      <path
        d="m76.112 204.198c0 24.561 19.981 44.542 44.542 44.542h34.702v-89.085h-34.702c-24.56 0-44.542 19.982-44.542 44.543z"
        fill="#915041"
      />
      <path
        d="m125.356 95.322v145.54c0 72.04 58.609 130.648 130.649 130.648s130.649-58.608 130.649-130.648v-145.54z"
        fill="#b46e5a"
      />
      <path
        d="m256.005 95.322v276.188c72.04 0 130.649-58.608 130.649-130.648v-145.54z"
        fill="#915041"
      />
      <path
        d="m351.911 28.562c-11.205-10.89-26.126-17.005-41.999-17.005-4.832 0-9.582.563-14.203 1.68-11.387-8.591-25.182-13.237-39.704-13.237-14.477 0-28.239 4.62-39.609 13.164-4.651-1.132-9.433-1.702-14.298-1.702-15.929 0-30.887 6.151-42.102 17.104-27.75.962-50.025 23.836-50.025 51.815 0 28.588 23.258 51.846 51.847 51.846 6.665 0 13.233-1.28 19.355-3.742 6.675 2.462 13.784 3.742 20.925 3.742 9.213 0 18.16-2.065 26.316-6.03 8.613 3.964 17.998 6.03 27.59 6.03 9.551 0 18.901-2.05 27.488-5.984 8.184 3.999 17.165 6.081 26.419 6.081 7.188 0 14.343-1.297 21.054-3.789 6.086 2.43 12.61 3.692 19.226 3.692 28.588 0 51.847-23.258 51.847-51.846.001-28.013-22.332-50.907-50.127-51.819z"
        fill="#373c41"
      />
      <g><path d="m293.672 185.157h30v30.002h-30z" fill="#373c41" /></g>
      <g><path d="m188.338 185.157h30v30.002h-30z" fill="#373c41" /></g>
      <g>
        <path
          d="m298.671 308.014h-9.999c-12.63 0-24.129-4.938-32.667-12.984-8.538 8.047-20.037 12.984-32.667 12.984h-9.999v-30h9.999c9.742 0 17.667-7.926 17.667-17.667h30c0 9.741 7.925 17.667 17.667 17.667h9.999z"
          fill="#373c41"
        />
      </g>
      <path
        d="m241.005 320.062v50.593c4.923.565 9.928.856 15 .856s10.077-.291 15-.856v-50.593z"
        fill="#373c41"
      />
      <g><path d="m293.672 185.157h30v30.002h-30z" fill="#292d31" /></g>
      <g fill="#292d31">
        <path
          d="m309.912 132.323c7.188 0 14.343-1.297 21.054-3.789 6.086 2.43 12.61 3.692 19.226 3.692 28.588 0 51.847-23.258 51.847-51.846 0-28.013-22.333-50.907-50.127-51.818-11.205-10.89-26.126-17.005-41.999-17.005-4.832 0-9.582.563-14.203 1.68-11.388-8.591-25.183-13.237-39.705-13.237v132.227c9.551 0 18.901-2.05 27.488-5.984 8.184 3.998 17.165 6.08 26.419 6.08z"
        />
        <path
          d="m288.672 278.014c-9.742 0-17.667-7.926-17.667-17.667h-15v34.683c8.538 8.047 20.037 12.984 32.667 12.984h9.999v-30z"
        />
        <path
          d="m271.005 370.655v-50.593h-15v51.449c5.072 0 10.077-.291 15-.856z"
        />
      </g>
    </g>
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "FatherIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
